<template>
  <div class="container">
    <div class="search-top">
      <div class="navi">
          <span class="close"><span class="icon-arrow-left" @click="close()"></span></span>
          <div class="top-title">请输入地址</div>
          <span></span>
      </div>
      <div class="weui-search-bar weui-search-bar_focusing" id="searchBar">
          <form class="weui-search-bar__form">
              <div class="weui-search-bar__box">
                  <i class="weui-icon-search"></i>
                  <input type="search" class="weui-search-bar__input" id="searchInput" placeholder="请输入地址" v-model="term" ref="searchBar" required/>
                  <a href="javascript:" class="weui-icon-clear" id="searchClear" @click="term='';setFocus()"></a>
              </div>
          </form>
      </div>
    </div>
    <div class="searchbar-result">
        <div class="notice-yellow" v-show="!searchResults" @click="setFocus()"> 输入地址以数字开头，如 2/9 George Street</div>
        <div class="weui-cells__title" v-show="searchResults">请点击选择您的地址</div>
        <div class="weui-cells" >
            <div class="weui-cell weui-cell_access"  v-for="item in searchResults">
                <div class="weui-cell__bd weui-cell_primary">
                    <p class="suburb-item" @click="selectAddr(item.id)"><span class="suburb-name">{{item.full_address}}</span></p>
                </div>
            </div>
        </div>
        <br>
        <div class="text-center" v-show="!searchResults && term.length>5 && !showEmpty" ><i class="weui-loading"></i></div>
        <div class="notice-red" v-show="showEmpty && term.length>8" >没有找到符合条件的地址<br>请确认是否输入正确</div>

    </div>

    <transition name="fade">
        <div id="loadingToast" v-show="isLoading">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在确认地址</p>
            </div>
        </div>
    </transition>
</div>
</template>

<script>
import Vue from 'vue'
import md5 from 'blueimp-md5'

export default {
  name: 'suburb-filter',
  data () {
    return {
      term:"",
      options:{keys: ["name", "postcode"],threshold:0.3},
      searchResults:"",
      ifTimeout : false,
      isLoading: false,
      showEmpty: false
    }
  },
  mounted() {
    this.$refs.searchBar.focus();
  },
  methods: {
    setFocus: function(){
      this.$refs.searchBar.focus();
    },
    close: function () {
      this.$emit('close')
    },
    getAddr(){
      let nonce_str = parseInt(Math.random() * 1000000)
      let timestamp = parseInt(new Date().getTime() / 1000)
      let sign = md5('content='+this.term.trim()+'&nonce_str='+nonce_str+'&timestamp='+timestamp+'&key=Qyc0&IRNwg9wtvYXIvAcmuqi5ihopwb2rn$F#dchvgpjTo3sch5j9tmeHNto6IP$').toUpperCase()
      let url = this.apiURL()+"/GoogleMap/autocomplete?content="+this.term.trim()+"&nonce_str="+nonce_str+"&timestamp="+timestamp+"&sign="+sign
      let that = this
      this.axios.get(url)
      .then(function (response) {
          that.searchResults = response.data.data.data;
          console.log(response.data.data.data)
          if(!response.data.data.status){
            that.showEmpty = true;
          }
          else{
            that.showEmpty = false;
          }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
    },
    selectAddr(place_id){
        this.isLoading = true;
        let nonce_str = parseInt(Math.random() * 1000000)
        let timestamp = parseInt(new Date().getTime() / 1000)
        let sign = md5('nonce_str='+nonce_str+'&place_id='+place_id+'&timestamp='+timestamp+'&key=Qyc0&IRNwg9wtvYXIvAcmuqi5ihopwb2rn$F#dchvgpjTo3sch5j9tmeHNto6IP$').toUpperCase()
        let url = this.apiURL()+"/GoogleMap/details?place_id="+place_id+"&nonce_str="+nonce_str+"&timestamp="+timestamp+"&sign="+sign
        let that = this
        this.axios.get(url)
        .then(function (response) {
            let data = response.data.data.data;
            let addressComponents = data.addressComponents;
            
            let subpremise = "";
            let street_number = "";
            let route = "";
            let locality = "";
            let state = "";
            let postcode = "";
            
            addressComponents.forEach(component => {
                if (component.types.includes('subpremise')) {
                    subpremise = component.longText;
                }
                if (component.types.includes('street_number')) {
                    street_number = component.longText;
                }
                if (component.types.includes('route')) {
                    route = component.shortText;
                }
                if (component.types.includes('locality')) {
                    locality = component.longText;
                }
                if (component.types.includes('administrative_area_level_1')) {
                    state = component.shortText;
                }
                if (component.types.includes('postal_code')) {
                    postcode = component.longText;
                }
            });
            
            // 🎯 关键修正：条件拼接逻辑
            let emit_street = "";
            if (subpremise && street_number && route) {
                emit_street = subpremise + "/" + street_number + " " + route;  // "suite 1007/109 Pitt St"
            } else if (street_number && route) {
                emit_street = street_number + " " + route;                     // "109 Pitt St"
            } else if (route) {
                emit_street = route;                                           // "Pitt St"
            }
            
            let emit_suburb = locality;
            emit_suburb = Vue.filter('lowercase')(emit_suburb);
            emit_suburb = Vue.filter('titlecase')(emit_suburb);
            let emit_state = state;
            let emit_postcode = postcode;
            
            that.isLoading = false;
            that.$emit('change',emit_street,emit_suburb,emit_state,emit_postcode);
        })
        .catch(function (error) {
            console.log(error);
            that.isLoading = false;
        })
    },
  },
  watch: {
    term: function (val) {
        if(val!=undefined){
            if(val.length>3){
                if (this.timeout) 
                clearTimeout(this.timeout); 
                this.timeout = setTimeout(() => { 
                    this.getAddr();
                }, 600); // delay
            }
        }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container{
  padding-top:0!important;
}

.search-top{
    position:fixed;
    top:0;
    z-index:9999;
    width:100%;
}

.navi{
    display: flex;
    justify-content:space-between;
    padding:0 0 0 0;
    width:100%;
    background:rgba(255, 255, 255, 0.94);
    span{
        flex: 1;
    }
    div{
        flex:2;
    }
    .close{
        text-align:left;
        font-size:1em;
        .icon-arrow-left{
            margin-right:12px;
            margin-top:12px;
            display:inline-block;
        }
    }
}
.icon-arrow-left{
    padding-left:12pt;
}
.top-title{
    font-size:0.5em;
    line-height:3.2em;
    color:#444;
    vertical-align:top;
    display:inline-block;
    text-align:center;
}

.suburb-item{
  font-size:0.9em;
}

.searchbar-result{
  margin-top:110px;
}

.btn.white.active{
  margin-top:14px;
}

.notice-yellow, .notice-red{
    margin:0 15px 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/address/index.vue